import { Button, Table, Tooltip } from 'antd'
import { useEffect } from 'react'
import { SDrawerOrModal, SLowcodeList, STags } from 'shj-components'
import { config } from './config'
import { findErrorResponseListByPage } from '@/services/product'
import { apiData2Table } from '@/utils/data'

export default function FailedDataModal(props: any) {
  const { open, loading, setOpen, onSubmit, title, record } = props

  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    return new Promise((resolve, reject) => {
      findErrorResponseListByPage({
        current: current,
        pageSize,
        batchKey: record.batchKey,
        ...rest.query,
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }
  const extensions = {
    request: { fetchList },
    scroll: { y: 550 },

  }
  return (
    <SDrawerOrModal
      mode="modal"
      open={open}
      loading={loading}
      onCancel={() => setOpen(false)}
      onOk={onSubmit}
      title={title}
      antdProps={{ footer: null }}
      width={800}
    >
      <SLowcodeList searchMode="group" config={config} {...extensions} />
    </SDrawerOrModal>
  )
}
